module.exports = __webpack_public_path__ + "img/a2.3381a731.png";